import React from 'react';
import { Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { categories } from '../../utils';
import { Title } from '@/components/Typography';
import * as S from './styles';

export function InformativeTable(): JSX.Element {
	return (
		<S.StyledDivInformations>
			<Row justify="center" align="middle">
				<S.StyledColHeader span={3} className="border-left">
					<Title level={5}>Category</Title>
				</S.StyledColHeader>
				<S.StyledColHeader span={9}>
					<Title level={5}>Action</Title>
				</S.StyledColHeader>
				<S.StyledColHeader span={12} className="border-right">
					<Title level={5}>Explanation</Title>
				</S.StyledColHeader>
			</Row>
			{categories.map((cat) => (
				<S.StyledLineRow justify="center" align="middle" key={cat.category}>
					<S.StyledLineCol span={3}>
						<S.CategorySquare color={cat.color}>
							<span>{cat.category}</span>
						</S.CategorySquare>
					</S.StyledLineCol>
					<S.StyledLineCol span={9}>
						<h3>{I18n.get(cat.action)}</h3>
					</S.StyledLineCol>
					<S.StyledLineCol span={12}>
						<h3>{I18n.get(cat.explanation)}</h3>
					</S.StyledLineCol>
				</S.StyledLineRow>
			))}
		</S.StyledDivInformations>
	);
}
